<template>
  <div class="txt_pop">
    <!-- <div class="txt" v-if="false">
      <h4>{{ $t('message.login.agreement.agreement_title') }}</h4>
      <p>{{ $t('message.login.agreement.one') }}</p>
      <p>
        {{ $t('message.login.agreement.h1n1') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h1n2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h1n3') }}
      </p>
      <p>{{ $t('message.login.agreement.two') }}</p>
      <p>
        {{ $t('message.login.agreement.h2n1') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h2n2') }}
      </p>
      <p>{{ $t('message.login.agreement.three') }}</p>
      <p>{{ $t('message.login.agreement.h3n1') }}</p>
      <p>
        {{ $t('message.login.agreement.h3n2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h3n3') }}
      </p>
      <p>{{ $t('message.login.agreement.h3n3s1') }}</p>
      <p>{{ $t('message.login.agreement.h3n3s2') }}</p>
      <p>{{ $t('message.login.agreement.four') }}</p>
      <p>
        {{ $t('message.login.agreement.h4n1') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n3') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n4') }}
      </p>
      <p>{{ $t('message.login.agreement.h4n4s1') }}</p>
      <p>
        {{ $t('message.login.agreement.h4n4s2') }}
      </p>
      <p>
        {{ $t('message.login.agreement.h4n4s3') }}
      </p>
      <p>{{ $t('message.login.agreement.h4n4s4') }}</p>
      <p>{{ $t('message.login.agreement.h4n5') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s1') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s2') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s3') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s4') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s5') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s6') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s7') }}</p>
      <p>{{ $t('message.login.agreement.h4n5s8') }}</p>
      <p>{{ $t('message.login.agreement.h4n6') }}</p>
      <p>{{ $t('message.login.agreement.h4n7') }}</p>
      <p>{{ $t('message.login.agreement.h4n8') }}</p>
      <p>{{ $t('message.login.agreement.h4n9') }}</p>
      <p>{{ $t('message.login.agreement.h4n10') }}</p>
      <p>{{ $t('message.login.agreement.five') }}</p>
      <p>{{ $t('message.login.agreement.h5n1') }}</p>
      <p>{{ $t('message.login.agreement.h5n2') }}</p>
      <p>{{ $t('message.login.agreement.h5n3') }}</p>
      <p>{{ $t('message.login.agreement.h5n4') }}</p>
      <p>{{ $t('message.login.agreement.six') }}</p>
      <p>{{ $t('message.login.agreement.h6n1') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s1') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s2') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s3') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s4') }}</p>
      <p>{{ $t('message.login.agreement.h6n1s5') }}</p>
      <p>{{ $t('message.login.agreement.h6n2') }}</p>
      <p>{{ $t('message.login.agreement.h6n3') }}</p>
      <p>{{ $t('message.login.agreement.h6n4') }}</p>
      <p>{{ $t('message.login.agreement.seven') }}</p>
      <p>{{ $t('message.login.agreement.h7n1') }}</p>
      <p>{{ $t('message.login.agreement.h7n2') }}</p>
      <p>{{ $t('message.login.agreement.h7n3') }}</p>
      <p>{{ $t('message.login.agreement.h7n4') }}</p>
      <p>{{ $t('message.login.agreement.h7n5') }}</p>
      <p>{{ $t('message.login.agreement.h7n5s1') }}</p>
      <p>{{ $t('message.login.agreement.h7n5s2') }}</p>
      <p>{{ $t('message.login.agreement.eight') }}</p>
      <p>{{ $t('message.login.agreement.h8n1') }}</p>
      <p>{{ $t('message.login.agreement.h8n2') }}</p>
      <p>{{ $t('message.login.agreement.h8n2s1') }}</p>
      <p>{{ $t('message.login.agreement.h8n2s2') }}</p>
      <p>{{ $t('message.login.agreement.nine') }}</p>
      <p>{{ $t('message.login.agreement.h9n1') }}</p>
      <p>{{ $t('message.login.agreement.h9n2') }}</p>

      <p>{{ $t('message.login.agreement.ten') }}</p>
      <p>{{ $t('message.login.agreement.h10n1') }}</p>
      <p>{{ $t('message.login.agreement.h10n2') }}</p>

      <p>{{ $t('message.login.agreement.eleven') }}</p>
      <p>{{ $t('message.login.agreement.h11n1') }}</p>
      <p>{{ $t('message.login.agreement.h11n2') }}</p>
      <p>{{ $t('message.login.agreement.twelve') }}</p>
      <p>{{ $t('message.login.agreement.h12n1') }}</p>
      <p>{{ $t('message.login.agreement.h12n2') }}</p>
      <p>{{ $t('message.login.agreement.h12n3') }}</p>
    </div> -->
    <!-- <div class="txt">
      签约条款
      用户在申请和使用本系统时，必须遵守本用户协议。您只有完全接受以下所有服务条款后，才能继续注册申请手续。一旦您完成注册申请，本网可以认为您已经详细阅读并确认同意接受本用户协议的所有条款。
      我承诺接受以下条款：
      一、用户在注册申请时自愿提供准确而详尽的个人资料，如个人资料有任何变动，必须及时更新；如果用户提供的个人资料不准确、不真实、不合法，本网保留结束用户使用本网各项服务的权利；由于用户提供的个人资料不准确、不真实、不合法所造成的损失，完全由用户本人承担；
      二、用户对所申请的帐号和密码安全负全部责任；本网尽量采取完备的网络安全措施，但是不能承担万一发生黑客攻击对用户造成的损失；用户若发现任何非法使用自己帐号或其它安全漏洞的情况，应立即通知本网；
      三、用户使用本网传输图文文件，须单方面承担对文件内容所应负的所有法律责任，包括核实影像内容的真实性，不侵犯他人肖像权和著作权等；
      四、本网保留随时修改或中断服务而不需通知用户的权利。用户接受本网行使修改或中断服务的权利，本网不需对用户或第三方负责；
      五、与本网签约的摄影师用户，本网有权将其图片介绍给使用客户。摄影师提供的图片，应符合本网所要求的技术参数，并应为每张图片提供符合本网标准的文字说明；
      六、摄影师用户授权本网拥有全球范围内的以下权利：有权从计算机硬盘、软盘、CD-ROM、数据库、网络服务器上编辑、储存用户图片；有权复制、展示和出售用户图片，并向各类国际互联网网站、报纸、杂志、广播电视、电子出版物以及其他现存和未来发展产生的的媒体提供相关的图片产品；有权制订用户图片的销售价格；有权批准和授权第三者使用上述权利；
      七、摄影师用户同意授权本网为在国际互联网上进行用户图片销售的唯一代理机构，即用户不得再将图片授权给其他与本网同样性质的网络图片代理机构使用，但仍拥有将图片直接出售给其他终端使用者的机构或个人的权利。若用户违反此条规定，本网有权单方解除本协议，本网同时保留向用户索赔经济损失的权利；
      八、摄影师用户同意在与本网解约后，本网不再享有唯一代理权，但仍有权存储和销售用户在本协议有效期间提供的图片的权利，并按原协议约定的条件向用户支付稿酬，同时用户亦可授权其他与本网同样性质的网络图片代理机构销售用户图片；
      九、摄影师用户保证对所提供的每张图片均拥有完整的合法的版权，用户图片不应涉及侵犯他人著作权、商标权、名誉权、隐私权及其它违法的内容。摄影师用户应对其所提供图片的违法内容所造成的一切后果承担相应的法律责任；
      十、如果发生第三人未经甲、乙任何一方授权而使用用户图片或其他对用户图片侵权的情形，则摄影师用户同意授权本网与第三方进行交涉；
      十一、为了扩大知名度，摄影师用户同意授权本网（“新摄荟”摄影平台，网址：http://zxp.mlyunai.com/）以及本网的所有权者免费使用并传播摄影师用户上传的图片的缩略图，鉴于目前网络未经同意转载图片缩略图的现象众多，摄影师用户同意放弃索取互联网上缩略图使用费的权利；
      十二、本网对摄影师实行累计付酬制，即按每张照片在本网被用户下载的次数多次付酬，但本网的所有权者可以在一次性付费的前提下，将摄影师用户提供的图片作为对外宣传通稿向海外播发；
      十三、本网拒绝向本网用户提供任何类型的担保；
      十四、用户承诺在使用本网提供的服务时，遵守所有适用于本网服务的地方法律、国家法律和国际法律。用户承诺：
      A、在本网的网页上发布信息或者利用本网的服务时必须符合中国有关法规，不得在本网的网页上或者利用本网的服务制作、复制、发布、传播以下信息：
      a) 反对宪法所确定的基本原则的； b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
      c) 损害国家荣誉和利益的； d) 煽动民族仇恨、民族歧视，破坏民族团结的； e)
      破坏国家宗教政策，宣扬邪教和封建迷信的； f) 散布谣言，扰乱社会秩序，破坏社会稳定的； g)
      散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； h)
      侮辱或者诽谤他人，侵害他人合法权益的； i) 含有法律、行政法规禁止的其他内容的。
      B、在本网的网页上发布信息或者利用本网的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。
      C、不利用本网的服务从事以下活动： a)
      未经允许，进入计算机信息网络或者使用计算机信息网络资源的； b)
      未经允许，对计算机信息网络功能进行删除、修改或者增加的； c)
      未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；
      d) 故意制作、传播计算机病毒等破坏性程序的； e) 其他危害计算机信息网络安全的行为。
      D、不以任何方式干扰本网的服务。 E、遵守本网的所有其他规定和程序。
      用户需对自己在使用本网服务过程中的行为承担法律责任。用户理解，如果本网发现其网站传输的信息明显属于上述第十四条A款所列内容之一，依据中国法律，本网有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。
      若用户的行为不符合以上提到的服务条款，本网将作出独立判断立即取消用户服务帐号。
      十五、用户或本网可随时根据实际情况中断服务。本网不需对任何个人或第三方负责而随时中断服务。用户若反对任何服务条款的建议或对后来的条款修改有异议，或对本网服务不满，用户只有以下的追索权：
      a) 不再使用本网服务； b) 结束用户使用本网服务的资格； c) 通告本网停止该用户的服务。
      结束用户服务后，用户使用本网服务的权利马上中止。从那时起，本网不再对用户承担任何义务。
    </div> -->
    <div class="txt" v-html="$t('message.my.enterpriseCertification')"></div>
  </div>
</template>

<script>
export default {
  name: 'UserTextPop'
}
</script>

<style lang="less">
// scoped : 使用的是模板字符串，没办法继承属性  所以把scoped去掉了
.txt_pop {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 32px;

  h4 {
    text-align: center;
    font-size: 18px;
    color: #1a1a1a;
    font-weight: 500;
  }

  p {
    margin: 10px 0;
    font-size: 14px;
    color: #1a1a1a;
  }
  .remove {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>
